"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _support = _interopRequireDefault(require("./support"));
var _initialize = require("./initialize");
var _operations = require("./operations");
var idb = {
  initializeAndConnect: _initialize.initializeAndConnect,
  support: {
    isSupported: _support["default"]
  },
  transaction: {
    getData: _operations.getData,
    addData: _operations.addData,
    updateData: _operations.updateData,
    removeData: _operations.removeData
  }
};
var _default = exports["default"] = idb;